import FeeModelCards from "components/FeeModelCards";
import type { ReactStoryblokComponent } from "types/storyblok";
import type { FeeModelCardsAdapterProps } from "./FeeModelCards.d";

const FeeModelCardsAdapter = ({
  blok: { content = [], infoBoxText },
}: ReactStoryblokComponent<FeeModelCardsAdapterProps>) => <FeeModelCards content={content} infoBoxText={infoBoxText} />;
export default FeeModelCardsAdapter;
